import { render, staticRenderFns } from "./materialManage.vue?vue&type=template&id=60738842"
import script from "./materialManage.vue?vue&type=script&lang=js"
export * from "./materialManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60738842')) {
      api.createRecord('60738842', component.options)
    } else {
      api.reload('60738842', component.options)
    }
    module.hot.accept("./materialManage.vue?vue&type=template&id=60738842", function () {
      api.rerender('60738842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/materialManage.vue"
export default component.exports